// extracted by mini-css-extract-plugin
module.exports = {"AccordionSection":"DescriptionSection_AccordionSection__3_2vB"};